import React from 'react';
import TransferOrderGroupManagementRouter from './TransferOrderGroupManagementRouter';

export default function TransferOrderGroupManagementPage() {
  return <TransferOrderGroupManagementRouter />;
}
